import { Context, createContext } from 'react'

import { registerSharedDependency } from 'core-components/helpers/MFHelper'
import { IButtonProps } from 'core-components/library/button'

export interface IPendingButton {
  callback: () => Promise<boolean>
  props?: IButtonProps
  calculateProps?: () => any
}

export interface IPendingDescription {
  parameters: string[]
  message: string
  buttons: IPendingButton[]
  ignoreParams?: any
  calculateChangedFields?: () => string[]
}

export type removeAddedPending = () => void
export type addPendingFn = (pendingDescription: IPendingDescription) => removeAddedPending

interface IUrlContext {
  registr: () => {
    addPendingFn: addPendingFn
    unregistr: () => void
  }
  checkPendings: () => Promise<boolean>
}

const URLContextLocal = createContext({} as IUrlContext)

export const URLContext = registerSharedDependency<Context<IUrlContext>>(
  'URLContext',
  () => URLContextLocal
)
